import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ResidentialService } from '../questionnaire-residential/residential.service';

@Component({
  selector: 'app-skippage',
  templateUrl: './skippage.component.html',
  styleUrls: ['./skippage.component.css']
})
export class SkippageComponent implements OnInit {
  modalRef: BsModalRef;

  constructor(private modalService: BsModalService,private router: Router,private residentialService: ResidentialService) { }

  ngOnInit() {
  }
  openModalWithClass(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  clearSession(){
    let path = sessionStorage.getItem('path');
    sessionStorage.clear();
    this.residentialService.questionnaireStatusObj.questionStep = '000';
    this.residentialService.userResponse.userResponses = null;
    if(path==='contact-us' || path==='precontact'){
      this.router.navigateByUrl('/faq/contact-us');
    }else if(path === 'giveback'){
      this.router.navigateByUrl('/giveback');
    }else if(path === 'blog'){
      this.router.navigateByUrl('/blog');
    }else if(path === 'faq'){
      this.router.navigateByUrl('/faq');
    }
    else {
      this.router.navigateByUrl('/');
    }
  }
   mailMe (mail) // <--- element on which you need to apply click
    {
        mail = document.createElement("a");
        mail.href = "mailto:hello@honestgorilla.com?subject=Question&body=Hi";
        mail.click();
    }

}
